import React from 'react';
import PreviewProvider from '@/context/previewContext';
import PreviewModal from './PreviewModal';

interface PreviewWrapperProps {
  children: React.ReactNode;
}

/**
 * PreviewWrapper component that provides preview functionality to its children.
 * This should be placed at a high level in your component tree, typically in your main App component.
 *
 * @example
 * ```tsx
 * function App() {
 *   return (
 *     <PreviewWrapper>
 *       <YourAppContent />
 *     </PreviewWrapper>
 *   );
 * }
 * ```
 */
const PreviewWrapper: React.FC<PreviewWrapperProps> = ({ children }) => {
  return (
    <PreviewProvider>
      {children}
      <PreviewModal />
    </PreviewProvider>
  );
};

export default PreviewWrapper;
